export default {
  // Images
  maxUploadImageSize: 5242880, // 10MB
  maxUploadImageMsg: '5MB', // 10MB
  imageMimes: ['image/jpeg', 'image/png']
};